export const allFeatureFlags = [
  'showMedicalRecord',
  'sponsorUsersWithAdminRoleForAlnylamTrial',
  'sitesCanAddExternalTrialsForPatientId',
  'nextStepsNewStatusForPatientTrialMatch',
  'showSliderWithHistogramFilter',
  'prescreeningSiteUserAccess',
  'siteSelectionLightHeading',
  'newPrescreeningTrialsPage',
] as const;

const featureFlagNotToAutomaticallyActivateForDev = [
  'hideTrialsAndApplicationsForSiteUser',
] as const;

export type FeatureFlag =
  | (typeof allFeatureFlags)[number]
  | (typeof featureFlagNotToAutomaticallyActivateForDev)[number];
